import { VStack } from '@chakra-ui/react';
import React from 'react';
import { spacing } from 'theme/tokens';
import FadeIn from './animations/FadeIn';

type Props = { children: React.ReactNode; animate?: boolean };

const STAGGER_MS = 60;

export default function PageLayout({ children, animate = true }: Props) {
    if (!animate) {
        return (
            <VStack spacing={spacing.sectionGap} align="stretch">
                {children}
            </VStack>
        );
    }

    const items = React.Children.toArray(children);

    return (
        <VStack spacing={spacing.sectionGap} align="stretch">
            {items.map((child, i) => (
                <FadeIn key={i} delay={i * (STAGGER_MS / 1000)} duration={0.35} distance={8}>
                    {child}
                </FadeIn>
            ))}
        </VStack>
    );
}
